/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/js/aa/common/aacom-ui-1.0.0.js
*    TO   --> ./webapps/shared-web/src/main/assets/js/common/aacom-ui-1.0.0.js
**/

/*
 * Sandbox for the aa.com application
 * Following sandbox pattern by Stoyan Stefanov
 * AAcom will contruct the sandbox (AAUI) for our application
 */

function AAcom() {
	// Turn arguments into an array
	var args = Array.prototype.slice.call(arguments),
	// The last argument is the callback
	callback = args.pop(),
	// Required modules can be passed as an array or as individual parameters
	modules = (args[0] && typeof args[0] === "string") ? args : args[0], i;

	// Make sure AAcom is called as a constructor
	if (!(this instanceof AAcom)) {
		return new AAcom(modules, callback);
	}

	// Add modules to the core 'this' object - no modules or "*" both mean "use
	// all modules"
	if (!modules || modules == '*') {
		modules = [];
		for (i in AAcom.modules) {
			if (AAcom.modules.hasOwnProperty(i)) {
				modules.push(i);
			}
		}
	}

	// Initialize the required modules
	for (i = 0; i < modules.length; i += 1) {
		AAcom.modules[modules[i]](this);
	}

	callback(this);
}

// This function switches the aria-expanded status. It will keep either just one aria-expanded as true or all of them as false.
function ariaExpandedSwitcher(element) {
    var headerIds = ["plan-travel-expander", "travel-information-expander", "aadvantage-expander", "myAccountDropdown", "myAccountDropdown-phone"];
    for (var i = 0; i < headerIds.length; i += 1) {

        //If the current element is the one who was clicked, it switches its aria-expanded state.
        if (element.getAttribute("id") == headerIds[i]) {
            if (element.getAttribute("aria-expanded") == "false") {
                element.setAttribute("aria-expanded", true);
            } else if (element.getAttribute("aria-expanded") == "true") {
                element.setAttribute("aria-expanded", false);
            }

        //If the current element was not clicked and its aria-expanded attribute was true, then it sets it as false.
        //This allows to have just one header expanded, or none of them.
        } else if (document.getElementById(headerIds[i]) !== null) {
            if (document.getElementById(headerIds[i]).getAttribute("aria-expanded") == "true") {
                document.getElementById(headerIds[i]).setAttribute("aria-expanded", false);
            }
        }
    }
}

// Add properties to the prototype as needed
AAcom.prototype = {
	// private fields
	_name : "AACom Sandbox",
	_version : "1.0.0",
	_vars : {},

	// public API
	getName : function() {
		return this._name;
	},
	getVersion : function() {
		return this._version;
	},
	getProperty : function(key) {
		return this._vars[key];
	},
	setProperty : function(obj) {
		for ( var key in obj) {
			if (!(key in this._vars)) {
				this._vars[key] = obj[key];
			}
		}
	}
};

// Static property of AAcom to contain our modules
AAcom.modules = {};
